import { RouteLocationNormalizedLoaded } from 'vue-router';

/**
 * The key a page's `<router-view>` mounts it under: its params. A query-only change (tabs,
 * filters, `?setId=`) keeps the page, a new param (record, account) remounts it, so record
 * pages just load on mount with no id watchers. Pages that react to a deep link in the query
 * watch that query key instead of reading it once in created().
 */
export const getPageKey = (route: RouteLocationNormalizedLoaded): string => JSON.stringify(route.params);
